import AppConfig from 'utils/app-config';

class SessionService {
  set(jwt, persist) {
    AppConfig.merge({ authToken: jwt });

    if (persist) {
      return localStorage.setItem('qpt', jwt);
    }

    return sessionStorage.setItem('qpt', jwt);
  }

  get() {
    const jwt = sessionStorage.getItem('qpt');

    if (jwt) {
      return jwt;
    }

    return localStorage.getItem('qpt');
  }

  clear() {
    AppConfig.merge({ authToken: null });
    localStorage.removeItem('qpt');
    sessionStorage.removeItem('qpt');
  }
}

export default new SessionService();
